import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  dataStores: null,
  storeListParams : {
    page: 1,
    size: 10,
  },
  screenListInStore: null,
  screenListInStoreParam: {
    page: 1,
    size: 10,
  },
  timezones: [],
  allStores: null,
  detailStore: null,
  allPlaylistsInStore: null,
  playlistsInStore: null,
  playlistsInStoreParam: {
    page: 1,
    size: 10,
  },
  mediaInStore: null,
  summaryStore: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListStores.success, (state, { payload }) => {
        state.dataStores = payload;
      })
      .addCase(actions.setListStoresParams, (state, { payload }) => {
        state.storeListParams = payload;
      })
      .addCase(actions.getListScreensInStore.success, (state, { payload }) => {
        state.screenListInStore = payload;
      })
      .addCase(actions.getListTimezones.success, (state, { payload }) => {
        state.timezones = payload;
      })
      .addCase(actions.getAllStores.success, (state, { payload }) => {
        state.allStores = payload;
      })
      .addCase(actions.getDetailStore.success, (state, { payload }) => {
        state.detailStore = payload;
      })
      .addCase(actions.getAllPlaylistsInStore.success, (state, { payload }) => {
        state.allPlaylistsInStore = payload;
      })
      .addCase(actions.getPlaylistsInStore.success, (state, { payload }) => {
        state.playlistsInStore = payload;
      })
      .addCase(actions.setPlaylistsInStoreParams, (state, { payload }) => {
        state.playlistsInStoreParam = payload;
      })
      .addCase(actions.getMediaInStore.success, (state, { payload }) => {
        state.mediaInStore = payload;
      })
      .addCase(actions.getSummaryStore.success, (state, { payload }) => {
        state.summaryStore = payload;
      })
      .addCase(actions.setScreenListInStoreParams, (state, { payload }) => {
        console.log('payload123', payload);
        state.screenListInStoreParam = payload;
      });
  },
});

/** TODO:
 * please replace store => your feature name
 * ex:
 *      my feature is booking 
 *  name sagas like
 *      storeServiceReducer => bookingServiceReducers
 * 
 * // TODO:
 * Move to rootReducer (src/store/root/reducers.ts) and import your feature reducer
 */
export const storeUIActions = Slice.actions;
const storeServiceReducer = Slice.reducer;
export default storeServiceReducer;
